import React from "react";

import { Stack, StackProps } from "./Stack";

export const VStack = React.forwardRef<
  React.ElementRef<typeof Stack>,
  StackProps
>(function VStack(props, ref) {
  return <Stack ref={ref} flexDirection={"column"} {...props} />;
});
